import { BuildModuleParamsType } from 'types/api-internal';
import {
  SugarMoneyApiPayoutProgressResponseType,
  SugarMoneyApiRequestPayoutResponseType,
  SugarMoneyApiSubmitPayoutRequestType,
  SugarMoneyApiSubmitPayoutResponseType,
} from 'types/common';
import { SugarMoneyApiCoinResponseType } from 'types/coin';
import {
  SugarMoneyApiPointsHistoryResponseType,
  SugarMoneyApiUserHoldingsRequestType,
  SugarMoneyApiUserHoldingType,
  SugarMoneyApiUserPreferencesType,
  SugarMoneyApiUserPreferencesUpdateType,
  SugarMoneyApiUserTicketsResponseType,
} from 'types/users';

export const userModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  getCreatedCoins: async () =>
    makeApiRequest<SugarMoneyApiCoinResponseType[]>({
      endpoint: 'user/coins',
      options: { method: 'get' },
    }),

  getPointsHistory: async () =>
    makeApiRequest<SugarMoneyApiPointsHistoryResponseType>({
      endpoint: 'user/points/history',
      options: { method: 'get' },
    }),

  getHoldings: async ({ solPriceUsd }: SugarMoneyApiUserHoldingsRequestType) =>
    makeApiRequest<SugarMoneyApiUserHoldingType[]>({
      endpoint: 'user/holdings',
      options: { method: 'get' },
      searchParams: { solPriceUsd },
    }),

  getPreferences: async () =>
    makeApiRequest<SugarMoneyApiUserPreferencesType>({
      endpoint: 'user/preferences',
      options: { method: 'get' },
    }),

  updatePreferences: async (data: Partial<SugarMoneyApiUserPreferencesUpdateType>) =>
    makeApiRequest<SugarMoneyApiUserPreferencesType>({
      endpoint: 'user/preferences',
      data,
      options: { method: 'patch' },
    }),

  getTickets: async () =>
    makeApiRequest<SugarMoneyApiUserTicketsResponseType>({
      endpoint: 'user/tickets',
      options: { method: 'get' },
    }),

  getFavorites: async () =>
    makeApiRequest<SugarMoneyApiCoinResponseType[]>({
      endpoint: 'user/favorites',
      options: { method: 'get' },
    }),

  creatorRewardsPayout: {
    request: async () =>
      makeApiRequest<SugarMoneyApiRequestPayoutResponseType>({
        endpoint: 'user/creator-rewards/payout/request',
        options: { method: 'post' },
      }),

    submit: (data: SugarMoneyApiSubmitPayoutRequestType) =>
      makeApiRequest<SugarMoneyApiSubmitPayoutResponseType>({
        endpoint: 'user/creator-rewards/payout/submit',
        data,
        options: { method: 'post' },
      }),

    inProgress: async () =>
      makeApiRequest<SugarMoneyApiPayoutProgressResponseType>({
        endpoint: 'user/creator-rewards/payout/in-progress',
        options: { method: 'get' },
      }),
  },
});
